module.exports = __webpack_public_path__ + "static/media/1POLICY44.8271190f.jpg";